import { useContext } from "react";
import { ShowContent } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { TallyDocAdmin } from "./TallyDocAdmin";
import { TallyDocClient } from "./TallyDocClient";

export const TallyDesignDocPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);
  const content = idRole === 3 ? <TallyDocClient /> : <TallyDocAdmin />;

  return <ShowContent error={""} isLoading={isLoading} content={content} />;
};
